import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'

import router from './router'
import store from './store'
// import 'lib-flexible'
import 'vant/lib/index.css'
import '../public/js/http.js'
import '../public/js/formatCheck.js'
// import '../public/js/vconsole.js'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import {
  utilsCCPC,
  utilsgetDictValue,
  utilsDurationConversion
} from '../public/js/utils'
// 全局方法挂载
Vue.prototype.utilsCCPC = utilsCCPC
Vue.prototype.utilsgetDictValue = utilsgetDictValue
Vue.prototype.utilsDurationConversion = utilsDurationConversion

Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.use(Vant)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
